import PropTypes from 'prop-types';

function Header({ children }) {
  return (
    <header className="relative flex min-h-18 items-start justify-between px-4 pb-6 pt-4 lg:px-6 lg:pt-4">
      {children}
    </header>
  );
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Header;
